import React from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import './GamePage.css';

const ShowPage = (props) => {

    return (
        <div>
            <img src={props.bgSrc} className='smallBg' alt=' ' />
            <Text className='City' value={props.text[props.lang].name} />
            <img className='Gorod1' src={props.srcImg} alt=''/>
            <img className='Gerb1' src={props.src} alt='' />
            <Text className='Link' value={(props.lang === 'rus') ? ('Фото: ' + props.text.address + '. Свободный доступ') : ('Kuva: ' + props.text.address + '. Yleinen käyttö')} />
            <Button className='GamePrev' onClick={() => props.onClick('prev')} hidden={(props.step === 0) ? true : false} />
            <Button className='ShowNext' onClick={() => props.onClick('ShowNext')}  />

        </div>
    );
};

export default ShowPage; 